import React from "react";
import { Box } from "@mui/material";
import { useAuth } from "../../../contexts/AuthProvider";
import { isBaileyProvider } from "../../../contexts/AuthProvider/AuthProvider.helpers";

interface IWhatsAppServiceToggleProps {
  onChange: (toBailey: boolean) => void;
}

export const WhatsAppServiceToggle: React.FC<IWhatsAppServiceToggleProps> = ({
  onChange,
}) => {
  const { whatsappService } = useAuth();

  return (
    <Box
      onClick={() => onChange(!isBaileyProvider(whatsappService))}
      sx={{
        display: "inline-flex",
        alignItems: "center",
        bgcolor: "grey.200",
        borderRadius: "8px",
        cursor: "pointer",
        userSelect: "none",
      }}
    >
      {(["META", "BAILEY"] as const).map((service) => {
        const active = (whatsappService.selectedService ?? "META") === service;
        return (
          <Box
            key={service}
            sx={{
              px: 1,
              py: "3px",
              borderRadius: "6px",
              fontSize: "0.7rem",
              fontWeight: active ? 700 : 400,
              color: active ? "primary.contrastText" : "text.secondary",
              bgcolor: active ? "primary.main" : "transparent",
              transition: "all 0.18s ease",
              lineHeight: 1.5,
              whiteSpace: "nowrap",
            }}
          >
            {service === "META" ? "Meta" : "Whatsapp QR"}
          </Box>
        );
      })}
    </Box>
  );
};
